
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/stazioni-sciistiche-aperte",
      function () {
        return require("private-next-pages/[region]/stazioni-sciistiche-aperte.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/stazioni-sciistiche-aperte"])
      });
    }
  